export const BrokerDialogType = {
  Select: "select",
  Pending: "pending"
};
